import React, { useState, useEffect } from "react";
import "./HomeHeader.css";
import TrackingGood from "./TrackingGood";

import img1 from "./assets/jeep.jpg";
import img2 from "./assets/dodge.jpg";
import img3 from "./assets/nassan.jpg";
import img4 from "./assets/jerti.png";

/* ================= SLIDES ================= */
const slides = [
  {
    id: 1,
    media: img4,
    title: "Zuluwhiskey Shopping Store",
    description: "Fast • Secure • Reliable shopping Experience",
  },
  {
    id: 2,
    media: img1,
    title: "Global Cargo Delivery",
    description: "We deliver your goods safely across borders",
  },
  {
    id: 3,
    media: img2,
    title: "Freight Forwarding",
    description: "Efficient shipping solutions for businesses",
  },
  {
    id: 4,
    media: img3,
    title: "Trusted Logistics Partner",
    description: "Your cargo is safe with us at every step",
  },
];

const HomeHeader = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 16000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero-wrapper">

      {/* ================= HERO ================= */}
      <header className="shipping-header">
        <div className="shipping-slider-container">

          {/* SLIDES */}
          {slides.map((slide, idx) => (
            <div
              key={slide.id}
              className={`shipping-slide ${idx === currentIndex ? "active" : ""}`}
            >
              <img
                className="slide-media"
                src={slide.media}
                alt={slide.title}
              />

              <div className="overlay" />

              <div className="shipping-text">
                <h1>{slide.title}</h1>
                <p>{slide.description}</p>
              </div>
            </div>
          ))}

          {/* DESKTOP TRACKING (PURE OVERLAY, NO LAYOUT IMPACT) */}
          <div className="tracking-desktop">
            <TrackingGood />
          </div>

          {/* INDICATORS */}
          <div className="shipping-indicators">
            {slides.map((_, idx) => (
              <span
                key={idx}
                className={`shipping-indicator ${
                  idx === currentIndex ? "active" : ""
                }`}
                onClick={() => setCurrentIndex(idx)}
              />
            ))}
          </div>

        </div>
      </header>

      {/* ================= MOBILE TRACKING (BELOW HERO) ================= */}
      <div className="tracking-mobile">
        <TrackingGood />
      </div>

    </div>
  );
};

export default HomeHeader;


